// context/LiveEditContext.js
import React, { createContext, useContext, useState } from 'react';

const LiveEditContext = createContext();

export const LiveEditProvider = ({ children }) => {
    const [edits, setEdits] = useState({
        title: 'Engineering',
        titleGradient: 'Excellence',
        subtitle1: 'Where precision meets performance.',
        subtitle2: 'Every line matters.',
        badge: 'Full-Stack Developer',
        gradientFrom: '#ffa500',
        gradientTo: '#ff6600'
    });

    const updateEdit = (key, value) => {
        setEdits(prev => ({ ...prev, [key]: value }));
    };

    const resetEdits = () => {
        setEdits({
            title: 'Engineering',
            titleGradient: 'Excellence',
            subtitle1: 'Where precision meets performance.',
            subtitle2: 'Every line matters.',
            badge: 'Full-Stack Developer',
            gradientFrom: '#ffa500',
            gradientTo: '#ff6600'
        });
    };

    return (
        <LiveEditContext.Provider value={{ edits, updateEdit, resetEdits }}>
            {children}
        </LiveEditContext.Provider>
    );
};

export const useLiveEdit = () => {
    const context = useContext(LiveEditContext);
    if (!context) {
        throw new Error('useLiveEdit must be used within LiveEditProvider');
    }
    return context;
};
